import "./LogisticsTimeline.css";
import moment from "moment";
import { useMemo } from "react";

/* ── Inline SVGs ── */
const UserIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const PackageIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
    <path d="M12 22V12" />
    <polyline points="3.29 7 12 12 20.71 7" />
    <path d="m7.5 4.27 9 5.15" />
  </svg>
);
const TruckIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
    <path d="M15 18H9" />
    <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
    <circle cx="17" cy="18" r="2" />
    <circle cx="7" cy="18" r="2" />
  </svg>
);
const MapPinIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const CheckIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const LockIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect width="11" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const ArrowLeftIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);
const HelpCircleIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <path d="M12 17h.01" />
  </svg>
);
const AlertTriangleIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 2 22h20a2 2 0 0 0 1.73-4" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </svg>
);
const InfoIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);
const PhoneIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
  </svg>
);
const ClockIcon = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);
const CircleCheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className="lt___check-icon"
  >
    <circle cx="12" cy="12" r="10" fill="#10b981" />
    <path
      d="m9 12 2 2 4-4"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LogisticsTimeline = ({ timeline }) => {
  const STATUS_CONFIG = useMemo(
    () => ({
      CREATED: {
        title: "Order Created",
        description: "Logistics order has been created",
        icon: <PackageIcon size={16} />,
      },
      PENDING: {
        title: "Pending",
        description: "Waiting for rider assignment / confirmation",
        icon: <UserIcon size={16} />,
      },
      ASSIGNED: {
        title: "Rider Assigned",
        description: "Delivery partner assigned",
        icon: <UserIcon size={16} />,
      },
      PICKED_UP: {
        title: "Picked Up",
        description: "Collected from restaurant",
        icon: <PackageIcon size={16} />,
      },
      IN_TRANSIT: {
        title: "In Transit",
        description: "En route to customer",
        icon: <TruckIcon size={16} />,
      },
      ARRIVED_AT_CUSTOMER: {
        title: "Arrived",
        description: "Reached delivery location",
        icon: <MapPinIcon size={16} />,
      },
      DELIVERED: {
        title: "Delivered",
        description: "Successfully completed",
        icon: <CheckIcon size={16} />,
      },
      FAILED: {
        title: "Delivery Failed",
        description: "Delivery unsuccessful",
        icon: <LockIcon size={16} />,
        statusBadge: "Failed",
        showActions: true,
      },
      CANCELLED: {
        title: "Cancelled",
        description: "Order cancelled",
        icon: <LockIcon size={16} />,
        statusBadge: "Cancelled",
      },
      RETURNING: {
        title: "Returning",
        description: "Return in progress",
        icon: <ArrowLeftIcon size={16} />,
      },
      RETURNED: {
        title: "Returned",
        description: "Returned to restaurant",
        icon: <ArrowLeftIcon size={16} />,
      },
      LOST: {
        title: "Lost",
        description: "Package lost",
        icon: <HelpCircleIcon size={16} />,
        statusBadge: "Lost",
      },
      DAMAGED: {
        title: "Damaged",
        description: "Package damaged",
        icon: <AlertTriangleIcon size={16} />,
        statusBadge: "Damaged",
      },
      RIDER_REACHED_PICKUP: {
        title: "Rider reached pickup",
        description: "Rider reached pickup location",
        icon: <PackageIcon size={16} />,
      },
      SHIPPED: {
        title: "Shipped",
        description: "Pickup completed. Delivery is currently in progress.",
        icon: <TruckIcon size={16} />,
      },
    }),
    []
  );

  const timelineSteps = useMemo(() => {
    const steps =
      timeline?.map((item, index) => {
        const config = STATUS_CONFIG[item?.status] || {};
        return {
          id: index + 1,
          title: config.title || item?.status,
          description: config.description || "",
          time: item?.time ? moment(item?.time).format("hh:mm A") : "N/A",
          icon: config.icon,
          status: "completed",
          statusBadge: config.statusBadge || null,
          showActions: config.showActions || false,
        };
      }) || [];

    const lastStatus = timeline?.length ? timeline[timeline.length - 1]?.status : "";
    if (["FAILED", "CANCELLED", "LOST", "DAMAGED"].includes(lastStatus)) {
      const lastStep = steps[steps.length - 1];
      if (lastStep) {
        lastStep.status = "failed";
        lastStep.showActions = true;
      }
    }

    return steps;
  }, [timeline, STATUS_CONFIG]);

  const progressPct = useMemo(() => {
    if (timelineSteps?.length <= 1) return 0;
    const completedCount = timelineSteps?.filter((s) => s?.status === "completed")?.length;
    return Math.max(0, ((completedCount - 1) / (timelineSteps?.length - 1)) * 100);
  }, [timelineSteps]);

  return (
    <div className="lt___container">
      {/* Static background track line */}
      <div className="lt___track" />
      {/* Emerald progress fill */}
      <div className="lt___progress" style={{ height: `${progressPct}%` }} />

      {timelineSteps?.map((step) => {
        const isCompleted = step?.status === "completed";
        return (
          <div key={step?.id} className="lt___step">
            {/* Dot */}
            <div className={`lt___dot${isCompleted ? " lt___dot--green" : " lt___dot--slate"}`}>
              <span className={isCompleted ? "lt___dot-icon--green" : "lt___dot-icon--slate"}>
                {step?.icon}
              </span>
            </div>

            {/* Content row */}
            <div className="lt___content">
              <div className="lt___left">
                <div className="lt___title-row">
                  <h4 className="lt___title">{step?.title}</h4>
                  {isCompleted && !step?.statusBadge && <CircleCheckIcon />}
                  {step?.statusBadge && <span className="lt___badge">{step.statusBadge}</span>}
                </div>
                <p className="lt___desc">{step?.description}</p>

                {step?.showActions && (
                  <div className="lt___actions">
                    <button type="button" className="lt___action-btn lt___action-btn--warning">
                      <InfoIcon size={16} /> Customer Not Reachable
                    </button>
                    <button type="button" className="lt___action-btn lt___action-btn--primary">
                      <PhoneIcon size={16} /> Contact Delivery Partner
                    </button>
                  </div>
                )}
              </div>

              <div className="lt___time">
                <ClockIcon size={14} />
                <span>{step?.time}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LogisticsTimeline;
